import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { environment } from 'src/environments/environment';
@Injectable({
  providedIn: 'root'
})
export class FicheAmiService {

  constructor(private http: HttpClient) { }

  /**
   *
   * @param filter {idAmi, page, limit, details}
   * @returns
   */
  findFicheAmi(filter: any, includes?: string[]) {
    let url = `${environment.apiUrl}/api/details/ami/fiche`;
    if (includes && includes.length > 0) {
      url += `?include=${includes.join(',')}`;
    }
    return this.http.post<any>(
      url,
      filter
    );
  }

  /**
   *
   * @param filter {item, maxKm}
   * @returns
   */
  searchFichesAmi(filter: any) {
    return this.http.post<any>(
      `${environment.apiUrl}/api/search/proximity/ami`,
      filter
    );
  }

  /**
   * @param param
   * @returns
   */
  contactAmi(param: any){
    return this.http.post<any>(
      `${environment.apiUrl}/api/contact/ami`,
      param
    );
  }
  /**
   * @param param
   * @returns
   */
  contact(param: any){
    return this.http.post<any>(
      `${environment.apiUrl}/api/contact`,
      param
    );
  }
}
